import React, { useState } from 'react';
import { Button } from 'antd';
import { ToolOutlined } from '@ant-design/icons';
import { usePermissions } from '../../contexts/PermissionContext';
import CrearCasoModal from './CrearCasoModal';
import { CrearCasoRequest } from '../../api/mejoraCU2Api';

interface Props { prefill: Partial<CrearCasoRequest>; }

/** Botón visible solo para quien puede gestionar; abre el modal de creación pre-rellenado. */
const AbrirCasoButton: React.FC<Props> = ({ prefill }) => {
  const { hasPermission } = usePermissions();
  const [open, setOpen] = useState(false);
  if (!hasPermission('GCvsc.MejoraCU2.Gestionar')) return null;
  return (
    <>
      <Button icon={<ToolOutlined />} onClick={() => setOpen(true)}>Abrir caso Mejora CU2</Button>
      <CrearCasoModal
        open={open}
        prefill={prefill}
        onClose={() => setOpen(false)}
        onCreated={() => setOpen(false)}
      />
    </>
  );
};

export default AbrirCasoButton;
